import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "action-menu" }
const _hoisted_2 = {
  class: "action-menu__menu",
  id: "actionMenu"
}

import { ref, ComponentPublicInstance, watch } from 'vue'

import BackgroundIcon from '@/assets/BackgroundIcon.svg'
import EffectsIcon from '@/assets/EffectsIcon.svg'
import LogoIcon from '@/assets/LogoIcon.svg'
import TextIcon from '@/assets/TextIcon.svg'
import ActionMenuTab from '@/components/action-menu/ActionMenuTab.vue'
import { useApplicationStore, ActionMenuTabs } from '@/store/application-store'
import { useProjectStore } from '@/store/project-store'
import useTextStates from '@/composables/UseTextStates'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionMenu',
  setup(__props) {

_useCssVars(_ctx => ({
  "15b17f95": (tabPadding),
  "56be5dba": (sliderPos.value)
}))


const tabPadding = '32px'
const sliderPos = ref(tabPadding)

const backgroundTab = ref<ComponentPublicInstance | null>(null)
const textTab = ref<ComponentPublicInstance | null>(null)
const logoTab = ref<ComponentPublicInstance | null>(null)
const effectsTab = ref<ComponentPublicInstance | null>(null)
const slider = ref<HTMLDivElement | null>(null)

const projectStore = useProjectStore()
const applicationStore = useApplicationStore()

const setSliderPosition = (tab: ActionMenuTabs) => {
  let activeElement

  switch (tab) {
  case ActionMenuTabs.BACKGROUND:
    if (backgroundTab.value) {
      activeElement = backgroundTab.value.$el as HTMLElement
    }
    break
  case ActionMenuTabs.TEXT:
    if (textTab.value) {
      activeElement = textTab.value.$el as HTMLElement
    }
    break
  case ActionMenuTabs.STICKERS:
    if (logoTab.value) {
      activeElement = logoTab.value.$el as HTMLElement
    }
    break
  case ActionMenuTabs.EFFECTS:
    if (effectsTab.value) {
      activeElement = effectsTab.value.$el as HTMLElement
    }
    break
  }
  if (activeElement && slider.value) {
    sliderPos.value = (activeElement.offsetWidth / 2) + activeElement.offsetLeft - (slider.value.offsetWidth / 2) + 'px' // set slider center to match the selected element's center
  }
}
const { addText } = useTextStates()

const onToggleActive = (tab: ActionMenuTabs) => {
  setSliderPosition(tab)
  applicationStore.activeActionTab = tab

  if (tab === ActionMenuTabs.TEXT) {
    if (projectStore.textStates.length === 0) {
      addText({ style: applicationStore.selectedText?.style })
    }
  } else {
    applicationStore.selectedText = null
  }

  if (tab !== ActionMenuTabs.STICKERS) {
    applicationStore.selectedSticker = null
  }
}

// Add application activeActionTab listener when editing text
watch(() => applicationStore.activeActionTab, () => {
  onToggleActive(applicationStore.activeActionTab)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "slider",
      ref: slider,
      class: _normalizeClass(['action-menu__slider'])
    }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ActionMenuTab, {
        ref_key: "backgroundTab",
        ref: backgroundTab,
        text: "Background",
        "is-active": _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).BACKGROUND,
        onToggleActive: _cache[0] || (_cache[0] = ($event: any) => (onToggleActive(_unref(ActionMenuTabs).BACKGROUND)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BackgroundIcon))
        ]),
        _: 1
      }, 8, ["is-active"]),
      _createVNode(ActionMenuTab, {
        ref_key: "textTab",
        ref: textTab,
        text: "Text",
        "is-active": _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).TEXT,
        onToggleActive: _cache[1] || (_cache[1] = ($event: any) => (onToggleActive(_unref(ActionMenuTabs).TEXT)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextIcon))
        ]),
        _: 1
      }, 8, ["is-active"]),
      _createVNode(ActionMenuTab, {
        ref_key: "logoTab",
        ref: logoTab,
        text: "Logo + Stickers",
        "is-active": _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).STICKERS,
        onToggleActive: _cache[2] || (_cache[2] = ($event: any) => (onToggleActive(_unref(ActionMenuTabs).STICKERS)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(LogoIcon))
        ]),
        _: 1
      }, 8, ["is-active"]),
      _createVNode(ActionMenuTab, {
        ref_key: "effectsTab",
        ref: effectsTab,
        text: "Effects",
        "is-active": _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).EFFECTS,
        onToggleActive: _cache[3] || (_cache[3] = ($event: any) => (onToggleActive(_unref(ActionMenuTabs).EFFECTS)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(EffectsIcon))
        ]),
        _: 1
      }, 8, ["is-active"])
    ])
  ]))
}
}

})